var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.languages,"label":_vm.$t('Primary Language')},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})}
var staticRenderFns = []

export { render, staticRenderFns }